import React from "react";
import PropTypes from "prop-types";
import StudioResizeHandles from "./StudioResizeHandles";
import StudioRotationHandle from "./StudioRotationHandle";
import StudioSelectionOverlay from "./StudioSelectionOverlay";

export default function StudioInteractionLayer({
  bounds = null,
  visible = true,
  resizeEnabled = true,
  rotationEnabled = true,
  disabled = false,
  rotationHandleOffset = 28,
  onResizePointerDown = null,
  onRotationPointerDown = null,
  children = null,
  className = "",
}) {
  if (!visible || !bounds) {
    return null;
  }

  return (
    <div
      className={[
        "studio-framework-interaction-layer",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      data-testid="studio-interaction-layer"
      aria-hidden="false"
    >
      <StudioSelectionOverlay
        bounds={bounds}
        visible
      >
        <StudioResizeHandles
          visible={resizeEnabled}
          onPointerDown={
            disabled
              ? null
              : onResizePointerDown
          }
        />

        <StudioRotationHandle
          visible={rotationEnabled}
          offset={rotationHandleOffset}
          disabled={disabled}
          onPointerDown={
            onRotationPointerDown
          }
        />

        {children}
      </StudioSelectionOverlay>
    </div>
  );
}

StudioInteractionLayer.propTypes = {
  bounds: PropTypes.shape({
    left: PropTypes.number,
    top: PropTypes.number,
    right: PropTypes.number,
    bottom: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    centerX: PropTypes.number,
    centerY: PropTypes.number,
  }),
  visible: PropTypes.bool,
  resizeEnabled: PropTypes.bool,
  rotationEnabled: PropTypes.bool,
  disabled: PropTypes.bool,
  rotationHandleOffset: PropTypes.number,
  onResizePointerDown: PropTypes.func,
  onRotationPointerDown: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
};
